export default __webpack_public_path__ + "static/media/252.f152ae5c.jpg";